<template>
  <div
    class="container pt-3 d-flex justify-content-center"
    style=""
    id="registration"
  >
    <div class="shadow bg-body rounder p-4">
      <h3 class="text-center mb-3">Регистрация сдатчика ягод</h3>
      <form @submit="onRegistration" class="">
        <div>
          <div class="col">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexSwitchHostel"
                v-model="form.hostel"
              />
              <label
                class="form-check-label"
                for="`flexSwitchHostel"
                >Являюсь сборщиком общежития</label
              >
            </div>
          </div>

          <div class="mb-3 row">
            <label for="lastName" class="col-sm-3 col-form-label"
              >Фамилия</label
            >
            <div class="col-sm-9">
              <input
                id="lastName"
                class="form-control"
                v-model="form.passport.lastName"
                type="text"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>

          <div class="mb-3 row">
            <label for="firstName" class="col-sm-3 col-form-label">Имя</label>
            <div class="col-sm-9">
              <input
                id="firstName"
                class="form-control"
                v-model="form.passport.firstName"
                type="text"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>

          <div class="mb-3 row">
            <label for="middleName" class="col-sm-3 col-form-label"
              >Отчество</label
            >
            <div class="col-sm-9">
              <input
                id="middleName"
                class="form-control"
                v-model="form.passport.middleName"
                type="text"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>

          <div class="mb-3 row">
            <label for="docNumber" class="col-sm-3 col-form-label"
              >Номер паспорта</label
            >
            <div class="col-sm-9">
              <input
                id="docNumber"
                class="form-control"
                v-model="form.passport.docNumber"
                type="text"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>

          <div class="mb-3 row">
            <label for="docIssueDate" class="col-sm-3 col-form-label"
              >Дата выдачи паспорта</label
            >
            <div class="col-sm-9">
              <input
                id="docIssueDate"
                class="form-control"
                v-model="form.passport.docIssueDate"
                type="date"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>

          <div class="mb-3 row">
            <label for="birthDate" class="col-sm-3 col-form-label"
              >Дата рождения</label
            >
            <div class="col-sm-9">
              <input
                id="birthDate"
                class="form-control"
                v-model="form.passport.birthDate"
                type="date"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>

          <div class="mb-3 row">
            <label for="country" class="col-sm-3 col-form-label"
              >Гражданство</label
            >
            <div class="col-sm-9">
              <select v-model="form.passport.country" class="form-select">
                <option value="643">Россия</option>
                <option value="112">Беларусь</option>
                <option value="804">Украина</option>
              </select>
            </div>
          </div>

          <div class="mb-3 row">
            <label for="city" class="col-sm-3 col-form-label">Город</label>
            <div class="col-sm-9">
              <input
                id="city"
                class="form-control"
                v-model="form.passport.city"
                type="text"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>

          <div class="mb-3 row">
            <label for="address" class="col-sm-3 col-form-label">Адрес</label>
            <div class="col-sm-9">
              <input
                id="address"
                class="form-control"
                v-model="form.passport.address"
                type="text"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>

          <div class="mb-3 row">
            <label for="postcode" class="col-sm-3 col-form-label"
              >Почтовый индекс</label
            >
            <div class="col-sm-9">
              <input
                id="postcode"
                class="form-control"
                v-model="form.passport.postcode"
                type="text"
                required
                placeholder=""
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>
        </div>

        <div class="mb-3 row">
          <label for="phone" class="col-sm-3 col-form-label">Телефон</label>
          <div class="col-sm-9">
            <div class="input-group">
              <span class="input-group-text" id="basic-addon1">+7</span>
              <input
                id="phone"
                class="form-control"
                v-model="form.phone"
                type="tel"
                pattern="[0-9]{10}"
                required
                placeholder="1234567890"
                @input="status.success = true"
                :disabled="singinReady"
              />
            </div>
          </div>
        </div>

        <div class="mb-3 row">
          <label for="email" class="col-sm-3 col-form-label">Email</label>
          <div class="col-sm-9">
            <input
              id="input-email"
              class="form-control"
              v-model="form.email"
              type="email"
              required
              placeholder=""
              @input="status.success = true"
              :disabled="singinReady"
            />
          </div>
        </div>
        <div class="mb-3 row">
          <label for="password" class="col-sm-3 col-form-label">Пароль</label>
          <div class="col-sm-9">
            <input
              id="password"
              class="form-control"
              v-model="form.password"
              type="password"
              required
              placeholder=""
              @input="status.success = true"
              :disabled="singinReady"
            />
          </div>
        </div>
        <div class="mb-3 row">
          <label for="password2" class="col-sm-3 col-form-label"
            >Пароль повторно</label
          >
          <div class="col-sm-9">
            <input
              id="password2"
              class="form-control"
              v-model="form.password2"
              type="password"
              required
              placeholder=""
              @input="status.success = true"
              :disabled="singinReady"
            />
          </div>
        </div>

        <div class="mb-0 row">
          <button :disabled="singinReady" type="submit" class="btn btn-light">
            Регистрация
          </button>
        </div>
        <div class="row">
          <span class="mt-3 text-danger text-center" v-if="!status.success">
            {{ status.err }}
          </span>
          <span class="mt-3 text-center" v-if="singinReady">
            <p>Вы успешно зарегистрировались</p>
            <router-link
              class="nav-link active btn btn-primary"
              type="button"
              aria-current="page"
              :to="{ name: 'login' }"
              >Войти</router-link
            >
          </span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";

export default {
  name: "Singup",
  components: {},

  setup(props) {
    const store = useStore();
    const router = useRouter();

    const form = ref({
      company: "",
      prefix: "",
      address: "",
      password: "",
      password2: "",
      email: "",
      phone: "",
      passport: {
        lastName: "",
        firstName: "",
        middleName: "",
        docNumber: "",
        docIssueDate: "", //ДД.ММ.ГГГГ
        birthDate: "", //ДД.ММ.ГГГГ
        country: "643", //Гражданство, РФ-643
        city: "",
        address: "",
        postcode: "",
      },
      role: "deliverer",
      passportImg: [],
      passportMain: "",
      _id: "",
      hostel: false,
    });

    const img = ref("");
    const handleFileUpload = (event) => {
      let file = event.target.files[0];
      console.log(file);

      let formData = new FormData();
      formData.append("file", file);

      axios.post("http://localhost:3005/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      axios
        .get("http://localhost:3005/download", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          img.value = Buffer.from(response.data, "binary").toString("base64");
        });
    };

    const status = ref({
      success: true,
      err: "",
    });

    const singinReady = ref(false);

    const onRegistration = async (evt) => {
      evt.preventDefault();
      if (form.value.password != form.value.password2) {
        status.value.success = false;
        status.value.err = "Пароли не совпадают";
      } else {
        status.value = await store.dispatch("singup", form.value);
        console.log(status.value);
        if (status.value.success) {
          singinReady.value = true;
          console.log("Успешно зарегались");
        }
      }
      await nextTick();
      window.scrollTo(0, document.body.scrollHeight);
    };

    return {
      status,
      store,
      form,
      singinReady,
      onRegistration,
      handleFileUpload,
      img,
    };
  },
};
</script>

<style scoped>
</style>

